var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stopExpertise"},[_c('el-dialog',{attrs:{"visible":_vm.stopVisible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }